import {
    FGFooter,
    FGTypography,
    FGLink,
    FGStack,
    FGStackItem,
} from '@fg/design-system';
import React from 'react';

const Footer = React.memo(() => {
    return (
        <FGFooter className="footer">
            <FGStack
                style={{ height: '100%' }}
                alignItems="center"
                justifyContent="space-between">
                <FGStackItem data-testid="footer-copyright">
                    <FGTypography color="strong" tag="p" variant="body3-short">
                      {`Copyright © ${new Date().getFullYear()} Fitch Solutions, Inc., BMI, and their subsidiaries.`}
                    </FGTypography>
                </FGStackItem>
                <FGStackItem>
                    <FGLink
                        appearance="blue"
                        data-testid="footer-policies"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.fitch.group/policies/">
                        <FGTypography
                            tag="label"
                            variant="link2"
                            cssStyle={{ cursor: 'pointer' }}>
                            Policies
                        </FGTypography>
                    </FGLink>
                </FGStackItem>
            </FGStack>
        </FGFooter>
    );
});

export default Footer;